import React from "react";

const ShopNow = () => {
  return (
    <button className="bg-primeColor text-white text-lg font-bodyFont w-[185px] h-[50px] hover:bg-black duration-300 font-bold">
      Shop Now
    </button>
  );
};

export default ShopNow;
